var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theory-libaray-main"},[_c('el-cascader',{attrs:{"options":_vm.topicTheoryLib,"props":_vm.props},on:{"change":_vm.libarayType},model:{value:(_vm.categoryArr),callback:function ($$v) {_vm.categoryArr=$$v},expression:"categoryArr"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }